<template>
  <div class="search-individual">
    <v-layout row wrap>
      <v-flex xs12 sm6 class="search-individual-select">
        <v-autocomplete
          v-model="selectedUser"
          @change="changeIndividualName"
          @keydown="keydownIndividualName"
          @keyup="keyupIndividualName"
          class="search-individual-input"
          :items="people"
          :label="$t('search_for_people_in_giver')"
          item-text="name"
          item-value="id"
          :loading="false"
          :hide-no-data="show"
          hide-details
          hide-selected
          solo
          flat
          :no-filter="noFilter"
          append-icon="icon-angle-down-18"
          attach=".ex-group-search"
        >
          <template slot="no-data">
            <v-list-tile-content v-text="$t('no_data_available')"/>
          </template>

          <template
            slot="item"
            slot-scope="{ item }"
          >
            <v-list-tile-avatar v-if="!item.avatar">
              <img src="../../../../src/assets/images/NoImage.png" :alt="$t('avatar')">
            </v-list-tile-avatar>
            <v-list-tile-avatar v-if="item.avatar">
              <img :src="apiUrl + item.avatar" :alt="$t('avatar')">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="item.name"
              />
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import infiniteScroll from 'v-infinite-scroll'
import {mapState} from 'vuex'

export default {
  name: 'SearchInvalidUsers',
  components: {
    'v-infinite-scroll': infiniteScroll
  },
  data () {
    return {
      show: true,
      noFilter: true,
      people: [],
      selectedUser: {},
      offset: 0,
      loading: false,
      limit: 10,
      search: '',
      apiUrl: process.env.ROOT_API,
      typingTimer: {},
      previousSearchData: {}
    }
  },
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData,
      accountInfo: state => state.accounts.accountInfo
    })
  },
  created () {
    if (this.accountInfo &&
      this.accountInfo.user &&
      this.loggedUser.id !== this.accountInfo.user.id &&
      this.$route.name === 'ProfileMyGroups') {
      this.selectedUser.id = this.accountInfo.user.id
      this.selectedUser.name = `${this.accountInfo.user.firstName} ${this.accountInfo.user.lastName}`
      this.selectedUser.avatar = this.accountInfo.user.image
    }
  },
  mounted () {
    this.getIndividualUsersList()
    // Detect when scrolled to bottom.
    this.$nextTick(e => {
      const listElm = document.querySelector('.v-autocomplete__content')
      if (listElm) {
        listElm.addEventListener('scroll', e => {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            this.getIndividualUsersList()
          }
        })
      }
    })
  },
  methods: {
    keyupIndividualName (e) {
      this.loading = true
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => {
        if (e.target && e.target.value && e.target.value.length > 2) {
          this.offset = 0
          this.people = []
          this.search = e.target.value
          this.getIndividualUsersList()
        } else if (e.target && e.target.value.length === 0) {
          this.offset = 0
          this.people = []
          this.search = e.target.value
          this.getIndividualUsersList()
        } else {
          this.loading = false
        }
      }, 400)
    },
    keydownIndividualName () {
      clearTimeout(this.typingTimer)
    },
    changeIndividualName (selectedUserId) {
      if (typeof selectedUserId === 'number') {
        this.$store.dispatch('accounts/clearAccountInfo', {})
        this.$router.push(`/accounts/${selectedUserId}`)
      }
    },
    getIndividualUsersList () {
      this.loading = true
      const searchData = {offset: this.offset, limit: this.limit, search: this.search}

      if (!this.previousSearchData.existItems && this.previousSearchData.offset === this.offset && this.previousSearchData.limit === this.limit && this.previousSearchData.search === this.search) {
        this.loading = false
        return false
      }
      this.$store.dispatch('friends/getSearchIndividualUsers', searchData)
        .then(response => {
          this.previousSearchData = {...searchData}
          this.previousSearchData.existItems = true

          if (response.length === 0) {
            this.previousSearchData.existItems = false
            this.show = false
          } else {
            this.offset += 10
          }
          response.forEach((res, i) => {
            if (res.status !== 2) {
              this.people.push({id: res.id, name: `${res.firstName} ${res.lastName}`, avatar: res.image})
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
  .search-individual-select {
      position: relative;
  }
  .search-individual-select i {
    position: absolute;
    right: 0;
    top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/SearchIndividualUsers.vue